export class Nature {
  codeHecate: number;
  designation: string;
  id: number;
  constructor(codeHecate: number, designation: string, id: number) {
    this.codeHecate = codeHecate;
    this.designation = designation;
    this.id = id;
  }
}
